import Tablelist from "@components/templates/tablelist";
import compUpdate from "./update";
import {
    HttpGetFuelSurchargeList,
    HttpDeleteFuelSurcharge
} from "@/service/fuelsurcharge";
import { mapState, mapGetters } from "vuex";
export default {
    mixins: [Tablelist],
    components: {
        compUpdate
    },
    data() {
        return {
            isMixin: true,
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Tools: { show: true },//工具栏
            Plugins: { show: true },//插件栏和各种弹框
        }
    },
    methods: {
        ajaxRequest: HttpGetFuelSurchargeList,
        interceptRequest (params) {
            return {
                ...params
            }
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.operate = {
                        show: true,
                        title: "添加",
                        width: 800,
                        querytype: 'add',
                        component: "compUpdate",
                        showFooter: false,
                    };
                    break;
                case "edit":
                    this.operate = {
                        title: "编辑",
                        show: true,
                        width: 800,
                        component: "compUpdate",
                        activeid: params.id,
                        querytype: 'edit',
                        showFooter: false
                    };
                    break;
                case "delete":
                    this.operate = {
                        title: "删除",
                        show: true,
                        alert: "warning",
                        params: {
                            id: params
                        },
                        ajaxRequest: HttpDeleteFuelSurcharge
                    }
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, lineId } = row;
            return [
                {
                    label: "编辑",
                    show: true,
                    params: {
                        id: id,
                        lineId: lineId
                    },
                    operate: "edit"
                },
                {
                    label: "删除",
                    show: true,
                    params: id,
                    operate: "delete"
                }
            ];
        },
    },
    computed: {
        ...mapGetters("dictionary", [ "getCountryList", ]),
        SearchsData() {
            return [
                {
                    label: "承运商",
                    tag: 'vSelect',
                    key: 'EQ_carrierCode',
                    hidden: !(this.formData.search['all'] == null),
                    show: true,
                    options:[
                        {label:'FedEx',value:'FedEx'},
                        {label:'UPS',value:'UPS'}
                    ]
                },
                {
                    label: '国家',
                    key: 'EQ_country',
                    tag: 'Select',
                    show: true,
                    options:this.getCountryList.map(item=>{
                        return {
                            value:item.value,
                            label:item.value
                        }
                    }),
                    props:{
                        filterable:true
                    }
                },
            ]
        },
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
            ]
        },
        columns() {
            return [
                {
                    show: false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: "操作",
                    width: 80,
                    render: this.getOperateNodes,
                    align: "center",
                },
                {
                    title: '承运商',
                    key: 'carrierCode',
                },
                {
                    title: '国家',
                    key: 'country',
                },
                {
                    title: "燃油费率",
                    key: "fuelRate"
                },
                {
                    title: '生效开始时间/生效结束时间',
                    render: (h, { row }) => {
                        if (row.beginTime == null && row.endTime == null) {
                            return <div>--</div>
                        } else {
                            return <div>
                        <span>{row.beginTime || '--'}</span>~<span>{row.endTime || '--'}</span>
                        </div> 
                        }
                    },
                },
                {
                    title: "创建人",
                    key: "createdName"
                },
                {
                    title: "创建日期",
                    key: "createdAt"
                }
            ]
        }
    }
}
